import { MultiSelect } from "@tql/ui-components-react/tql/dropdowns";

import type { AccessorialDetail } from "./accessorial-services-list.tsx";
import styles from "./accessorial-services-list-mobile.module.css";

type AccessorialServicesListMobileProps = Readonly<{
	disabled?: boolean;
	details: AccessorialDetail[];
	selectedDetails: AccessorialDetail[];
	onChange: (details: AccessorialDetail[]) => void;
}>;

export function AccessorialServicesListMobile({
	disabled = false,
	details,
	selectedDetails,
	onChange,
}: AccessorialServicesListMobileProps) {
	return (
		<div className={styles.accessorialServicesListMobileWrapper}>
			<MultiSelect
				data={details}
				dataItemKey={"id"}
				disabled={disabled}
				onChange={(event: { value: AccessorialDetail[] }) =>
					onChange(event.value)
				}
				tagLimit={3}
				tagLimitShowAllByDefault={true}
				textField={"name"}
				value={selectedDetails}
			/>
		</div>
	);
}
